interface WizardStepsProps {
  currentStep: number;
}

const STEPS = [
  { num: 1, label: "Kampanya Bilgileri" },
  { num: 2, label: "Hedef Kitle" },
  { num: 3, label: "Mesaj Hazırla" },
  { num: 4, label: "Önizle & Başlat" },
];

export default function WizardSteps({ currentStep }: WizardStepsProps) {
  return (
    <div className="flex items-center w-full">
      {STEPS.map((step, idx) => (
        <div key={step.num} className="flex items-center flex-1">
          <div className="flex flex-col items-center">
            <div
              className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold transition-all
                ${currentStep === step.num
                  ? "bg-[#25D366] text-white shadow-md shadow-[#25D366]/40"
                  : currentStep > step.num
                  ? "bg-[#0B1120] text-white"
                  : "bg-gray-100 text-gray-400"
                }
              `}
            >
              {currentStep > step.num ? <i className="ri-check-line text-sm"></i> : step.num}
            </div>
            <span
              className={`mt-1.5 text-[11px] font-medium text-center leading-tight hidden sm:block
                ${currentStep >= step.num ? "text-gray-700" : "text-gray-400"}
              `}
            >
              {step.label}
            </span>
          </div>
          {idx < STEPS.length - 1 && (
            <div className={`flex-1 h-0.5 mx-2 rounded-full transition-all ${currentStep > step.num ? "bg-[#25D366]" : "bg-gray-200"}`} />
          )}
        </div>
      ))}
    </div>
  );
}